// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Wi6n","tabsBox":"styles_tabsBox__7D0R1","createButton":"styles_createButton__2uiDq"};